export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑系列',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ fabricSeriesStatus, }) => {
      return !['N', 'R'].includes(fabricSeriesStatus)
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除系列',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ fabricSeriesStatus, }) => {
      return !['N', 'R'].includes(fabricSeriesStatus)

    },
  },
  {
    text: that.$l('btn_applyFullMember') || '提交审核',
    icon: 'el-icon-circle-check',
    menuType: 'apply',
    // allow: 'F',
    divided: true,
    disabled: ({ fabricSeriesStatus, }) => {
      return !['N', 'R'].includes(fabricSeriesStatus)

    },
  },
  {
    text: that.$l('btn_add_fabric') || '添加面料',
    icon: 'el-icon-circle-plus-outline',
    menuType: 'addFabric',
    // allow: 'K',
    disabled: ({ fabricSeriesStatus }) => !['Y'].includes(fabricSeriesStatus),
  },
]
